export default (state = {}, action = {}) => (
	action.type === 'PAGE_DATA' ? {
		...state,
		[action.page]: {
			...action.data,
		},
	} : state
);
